// Gemeinsame Definition der Dashboard-Kacheln und der Filterlogik.
// Bewusst ohne Imports, ohne JSX, ohne Tailwind-Klassen und ohne Icons:
// __tests__/dashboardFilter.node.test.cjs laedt diese Datei als Text.

const LEXWARE_ZU_PRUEFEN = ['error', 'conflict', 'unchecked'];

// Als abgerechnet gilt: Häkchen von Hand ODER eine in Lexware existierende Rechnung.
// draft und voided zählen nicht — Storno zählt zurück.
const VOUCHER_ABGERECHNET = ['open', 'paid', 'paidoff', 'overdue'];

export function istAbgerechnet(item) {
  return (item && item.billing_sent === true)
    || VOUCHER_ABGERECHNET.includes(item ? item.lexware_voucher_status : undefined);
}

export function istLexwareZuPruefen(item) {
  const ts = item && item.timesheet;
  return LEXWARE_ZU_PRUEFEN.includes(ts ? ts.lexware_status : undefined);
}

export const TILES = [
  {
    value: 'alle',
    label: 'Alle',
    subtitle: 'Einsätze',
    count: (items) => (items || []).length,
  },
  {
    value: 'green',
    label: 'Eingereicht',
    subtitle: 'Stundenzettel',
    count: (items) => (items || []).filter((it) => it.ampel_status === 'green').length,
  },
  {
    value: 'yellow',
    label: 'In Bearbeitung',
    subtitle: 'Stundenzettel',
    count: (items) => (items || []).filter((it) => it.ampel_status === 'yellow').length,
  },
  {
    value: 'red',
    label: 'Nicht erstellt',
    subtitle: 'Stundenzettel',
    count: (items) => (items || []).filter((it) => it.ampel_status === 'red').length,
  },
  {
    value: 'overtime',
    label: 'Mehrstunden',
    subtitle: 'Stundenzettel',
    count: (items) => (items || []).filter((it) => it.has_overtime === true).length,
  },
  {
    value: 'billed',
    label: 'Abgerechnet',
    subtitle: 'Rechnung erstellt',
    count: (items) => (items || []).filter((it) => istAbgerechnet(it)).length,
  },
  {
    value: 'lexware_check',
    label: 'Rechnung: zu prüfen',
    subtitle: 'Fehler / Konflikt / ungeprüft',
    count: (items) => (items || []).filter((it) => istLexwareZuPruefen(it)).length,
  },
  {
    value: 'kind_krank',
    label: 'Kind krank: zu prüfen',
    subtitle: 'Über dem Limit',
    count: (items) => (items || []).filter((it) => !!(it && it.kind_krank_warnung)).length,
  },
];

export function applyFilters(items, opts) {
  const o = opts || {};
  const status = o.status || 'alle';
  const jugendamt = o.jugendamt || 'alle';
  const q = String(o.search == null ? '' : o.search).trim().toLowerCase();

  return (items || []).filter((it) => {
    if (status === 'overtime') {
      if (it.has_overtime !== true) return false;
    } else if (status === 'billed') {
      if (!istAbgerechnet(it)) return false;
    } else if (status === 'lexware_check') {
      if (!istLexwareZuPruefen(it)) return false;
    } else if (status === 'kind_krank') {
      if (!it.kind_krank_warnung) return false;
    } else if (status !== 'alle') {
      if (it.ampel_status !== status) return false;
    }

    const asg = it.assignment || {};
    if (jugendamt !== 'alle' && asg.jugendamt_id !== jugendamt) return false;

    if (q) {
      const emp = it.employee || {};
      const hay = [emp.first_name, emp.last_name, emp.email, asg.child_name, asg.school_name]
        .map((x) => String(x == null ? '' : x).toLowerCase())
        .join(' ');
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}
